import { render, staticRenderFns } from "./myCollect.vue?vue&type=template&id=1dc04a14&scoped=true"
import script from "./myCollect.vue?vue&type=script&lang=js"
export * from "./myCollect.vue?vue&type=script&lang=js"
import style0 from "./myCollect.vue?vue&type=style&index=0&id=1dc04a14&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dc04a14",
  null
  
)

export default component.exports